var _line, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntreruptorCuPlutitorContactNormalInchis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 83,
    viewBox: "0 0 76 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 41,
    x2: 27,
    y2: 41,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 41L34 41",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 31L30 14.8024L30 3.25567e-07",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 30H45.9511H62.9022",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 82.6016L30 48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43 24.9023L30 49",
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 42C19.5 42.7849 18.8174 43.7792 17.0594 44.6368C15.3685 45.4616 12.9622 46 10.25 46C7.53775 46 5.13153 45.4616 3.44058 44.6368C1.68256 43.7792 1 42.7849 1 42C1 41.2151 1.68256 40.2208 3.44058 39.3632C5.13153 38.5384 7.53775 38 10.25 38C12.9622 38 15.3685 38.5384 17.0594 39.3632C18.8174 40.2208 19.5 41.2151 19.5 42Z",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 37V22",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntreruptorCuPlutitorContactNormalInchis);
export default __webpack_public_path__ + "static/media/intreruptor_cu_plutitor_contact_normal_inchis.817fde41d95eb74a4579871534069d3c.svg";
export { ForwardRef as ReactComponent };